
/**
 * Cookie configuration options and helper functions
 */

/**
 * Interface for cookie options
 */
export interface CookieOptions {
  expires?: number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
}

/**
 * Default cookie options
 */
export const DEFAULT_COOKIE_OPTIONS: CookieOptions = {
  expires: 30, // days
  path: '/',
  sameSite: 'strict'
};

/**
 * Serializes cookie options into a string for use in cookie setting
 */
export function serializeOptions(options: CookieOptions): string {
  const parts: string[] = [];
  
  if (options.expires) {
    const date = new Date();
    date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
    parts.push(`expires=${date.toUTCString()}`);
  }
  
  if (options.path) parts.push(`path=${options.path}`);
  if (options.domain) parts.push(`domain=${options.domain}`);
  if (options.secure === true) parts.push('secure');
  if (options.sameSite) parts.push(`sameSite=${options.sameSite}`);
  
  return parts.join('; ');
}
